<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import { ref, defineExpose } from "vue";
import { useRouter } from 'vue-router'
import Loading from 'vue3-loading-overlay';
import MyPageResumeModalBody from "../mypage/MyPageResumeModalBody.vue";
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import jobFairUserService from "../../../services/jobFair/jobFairUserService";
import {useUserStore} from "@/pages/user/stores/user";
import AlertCustomModal from "@/pages/user/components/modal/jobFair/AlertCustomModal.vue";

const router = useRouter();
const loadingStore = usePageLoadingStore()

const baseModal = ref(null);
const resolvePromise = ref(null);

const modalBody = ref(null);
const alertModal = ref(null);
const confirmModal = ref(null);
const alertCustomModal = ref(null);
const modalContent = ref([]);
const okButtonText = ref("네");
const cancelButtonText = ref("아니오");

const loaded = ref(false);

const showButtons = ref(false); // 수정, 삭제 버튼 : 마이페이지/특별채용관/구직자 이력서 클릭 시 나오는 버튼
const resumeIds = ref(0);
const ojfIds = ref(0);
const jobNoticeSeqs = ref(0);
const applicantYns = ref(false);

const { user } = useUserStore() // 사용자 정보


// 마이페이지 특별채용관 이력서 보기
const retrieveJobFairRecordDetail = (resumeId, ojfId) => {
  resumeIds.value = resumeId;
  ojfIds.value = ojfId;
  loaded.value = false;

  if(resumeId) {
    let paramObj = {
      resumeId: resumeId,
      hidden: 0,
    }
    jobFairUserService.ojfResumeDetail(paramObj)
        .then( (res) => {
          loaded.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            modalBody.value.setHidden(0);
            modalBody.value.setRecord(result);
          }
        }).catch( (error) =>  {
      loaded.value = true;
      console.log(error);
    });
  }
}

// 이력서 수정 버튼
const onClickChangeResume = (resumeId, ojfId) => {
  // 특별채용관 채용공고에 입사지원한적 있는 이력서 인지 체크하여 데이터 전달
  if(applicantYns.value === 'N') {
    router.push({ name: 'MyPageJobFairResume', query : { resumeId: resumeId, ojfId: ojfId, jobNoticeSeq: jobNoticeSeqs.value } });
  } else {
    router.push({ name: 'MyPageJobFairResume', query : { resumeId: resumeId, ojfId: ojfId } });
  }
}

// 입사지원하기
const onClickCreateApplicant = async (ojfId, jobNoticeSeq, resumeId) => {
  ojfIds.value = ojfId;
  jobNoticeSeqs.value = jobNoticeSeq;

  modalContent.value = ["선택한 이력서로", "입사 지원 하시겠습니까?"];
  okButtonText.value = "입사지원";

  const ok = await confirmModal.value.show();
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      ojfId: ojfId,
      jobNoticeSeq: jobNoticeSeq,
      resumeId: resumeId,
    }

    loadingStore.loading = true;
    jobFairUserService.ojfCreateApplyStateGb(paramObj)
        .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            // const result = res.data.result;
            await alertCustomModal.value.show();

            baseModal.value.close();
            resolvePromise.value(false);

          }
        }).catch( (error) =>  {
      loadingStore.loading = false;
      console.log(error);
    });
  }
}

const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = async () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

const init = (showButton, jobNoticeSeq, applicantYn) => {
  // 기본값 저장
  showButtons.value = showButton; // 수정, 선택 버튼

  jobNoticeSeqs.value = jobNoticeSeq;
  applicantYns.value = applicantYn; // 입사지원 여부 확인
}

defineExpose({
  show,
  init,
  retrieveJobFairRecordDetail,
})
</script>

<template>
  <Modal ref="baseModal" class="vld-parent">
    <loading
        :active="!loaded"
        loader="dots"
        color="#3843AF"
        opacity="0.5"
        width="35"
        :is-full-page="false"></loading>
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body" v-show="loaded">
        <MyPageResumeModalBody ref="modalBody"/>
      </div>
      <div v-if="showButtons" class="modal-footer btn-wrap">
        <KSAPrimaryButton v-if="applicantYns === 'N'" text="수정" @click="onClickChangeResume(resumeIds, ojfIds)" />
        <KSAPrimaryButton v-if="applicantYns === 'N'" text="선택" @click="onClickCreateApplicant(ojfIds, jobNoticeSeqs, resumeIds)" />
      </div>
    </div>
  </Modal>
  <AlertModal ref="alertModal" :content="modalContent" />
  <ConfirmModal ref="confirmModal" :content="modalContent" :okButtonText="okButtonText" :cancelButtonText="cancelButtonText" />
  <AlertCustomModal ref="alertCustomModal" :content="modalContent" /> <!-- 커스텀 팝업: 입사지원 완료 -->

</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>